import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  getEntity,
  hasEntity,
  selectEntity,
  updateEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { isNumber } from '@4players/odin-common';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';
import { tenantStorageKey } from '../shared/helpers/tenant';

const PARTICIPANT_SETTINGS_STORE_NAME = 'andorParticipantSettings.v1';

export type ParticipantSettings = {
  id: string;
  volume: number | null;
  isFavorite: boolean;
};

const participantSettingsStore = createStore(
  { name: PARTICIPANT_SETTINGS_STORE_NAME },
  withEntities<ParticipantSettings>()
);

persistState(participantSettingsStore, {
  key: tenantStorageKey(PARTICIPANT_SETTINGS_STORE_NAME),
  storage: localStorageStrategy,
});

@Injectable({
  providedIn: 'root',
})
export class ParticipantSettingsStore {
  readonly store = participantSettingsStore;

  get value() {
    return this.store.value;
  }

  get$(id: string): Observable<ParticipantSettings | undefined> {
    return this.store.pipe(selectEntity(id));
  }

  getVolume$(id: string) {
    return this.store.pipe(
      selectEntity(id, { pluck: 'volume' }),
      map((volume) => {
        if (isNumber(volume)) {
          return volume;
        }
        return 1;
      })
    );
  }

  getIsFavourite$(id: string) {
    return this.store.pipe(selectEntity(id, { pluck: 'isFavorite' }));
  }

  get(id: string): ParticipantSettings | undefined {
    return this.store.query(getEntity(id));
  }

  add(user: ParticipantSettings): void {
    this.store.update(addEntities(user));
  }

  has(id: string): boolean {
    return this.store.query(hasEntity(id));
  }

  update(particpant: ParticipantSettings) {
    this.store.update(updateEntities(particpant.id, () => particpant));
  }

  delete(id: string): void {
    this.store.update(deleteEntities(id));
  }
}
